import { render } from "./Loader.vue?vue&type=template&id=59cd573b&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=59cd573b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cd573b"]])

export default __exports__